module.exports = __webpack_public_path__ + "media/images/flags/4x3/nfk-d3f4a2c0d959ffe9e37b95507f539b5b.svg";